import { SearchItem_DiseaseProfile } from '@app/dp-frontend/search/index';
import { Component_SearchAddOn_ByTag, SearchAddOn_ByTag, SearchItemPack_HealthCareSpace } from '@app/hcs-frontend/search/index';
import { Component_SearchAddOn_PathwayStatus, SearchAddOn_PathwayStatus } from '@app/pathway-frontend/search/add-ons/SearchAddOn_PathwayStatus/index';
import { SearchItem_Pathway } from '@app/pathway-frontend/search/items/pathway';
import { SearchItem_Action } from '@app/pathway-frontend/search/items/action';
import { SearchItem_OrderGroup } from '@app/pathway-frontend/search/items/order-group';
import { SearchItemPack_AdvisorUI } from '@app/advisor-ui-frontend/search/index';
import { SearchItemPack_FHIR } from '@app/fhir-frontend/search/index';
import { SearchItemPack_AdvisorContext, SearchItemPack_SmartDocs } from '@app/advisor-content-frontend/search/index';
import { QuaiBaseAddOns } from '@app/styles';
import { AddOn_EntityFilter, Component_AddOn_EntityFilter, SearchContext, SearchSorter_Label, SearchSorter_SearchTerms } from '@nu-art/search';
import { DBDef_Expression, DBDef_Variable } from '@app/hcs-shared';
import { DBDef_Pathway } from '@app/pathway-shared';
import { DBDef_DiseaseProfile } from '@app/dp-shared';
import { SearchItem_AIPrompt } from '@app/styles/ai-prompts/integration';
export const SearchContext_Global = new SearchContext('global')
    .setSearchItems([...SearchItemPack_HealthCareSpace,
    ...SearchItemPack_AdvisorUI,
    ...SearchItemPack_FHIR,
    ...SearchItemPack_SmartDocs,
    ...SearchItemPack_AdvisorContext,
    SearchItem_Pathway,
    SearchItem_DiseaseProfile,
    SearchItem_Action,
    SearchItem_OrderGroup,
    SearchItem_AIPrompt,
])
    .setAddOns([...QuaiBaseAddOns, SearchAddOn_ByTag, SearchAddOn_PathwayStatus])
    .setSorters([SearchSorter_Label, SearchSorter_SearchTerms])
    .setMinimumRequiredActiveAddOns(2)
    .retainFilters();
export const UIControlledAddons = [AddOn_EntityFilter, SearchAddOn_ByTag, SearchAddOn_PathwayStatus];
export const UIControlledAddOnRendererMap = {
    [AddOn_EntityFilter.key]: {
        component: Component_AddOn_EntityFilter,
        props: {
            permanentOnScreenEntityKeys: [
                DBDef_Pathway.dbKey,
                DBDef_Variable.dbKey,
                DBDef_DiseaseProfile.dbKey,
                DBDef_Expression.dbKey,
            ]
        },
    },
    [SearchAddOn_ByTag.key]: { component: Component_SearchAddOn_ByTag },
    [SearchAddOn_PathwayStatus.key]: { component: Component_SearchAddOn_PathwayStatus },
};
